"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconImageFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15 2C15 1.44772 14.5523 1 14 1H2C1.44771 1 1 1.44772 1 2V14C1 14.5523 1.44771 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM10.625 6.49997C11.2463 6.49997 11.75 5.99629 11.75 5.37497C11.75 4.75365 11.2463 4.24997 10.625 4.24997C10.0037 4.24997 9.5 4.75365 9.5 5.37497C9.5 5.99629 10.0037 6.49997 10.625 6.49997ZM4.77077 6.04702L3 8.28964V13H13V9.69411L11.6676 8.26042C11.4786 8.05703 11.2135 7.94138 10.9359 7.94117C10.6582 7.94097 10.3929 8.05622 10.2036 8.25933L9.04696 9.5002L6.34266 6.04984C6.1535 5.80849 5.86405 5.66727 5.5574 5.66672C5.25075 5.66617 4.9608 5.80634 4.77077 6.04702Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M19 2C19 1.44772 18.5523 1 18 1H2C1.44772 1 1 1.44772 1 2V18C1 18.5523 1.44772 19 2 19H18C18.5523 19 19 18.5523 19 18V2ZM13.5 8C14.3284 8 15 7.32843 15 6.5C15 5.67157 14.3284 5 13.5 5C12.6716 5 12 5.67157 12 6.5C12 7.32843 12.6716 8 13.5 8ZM5.95593 7.60256L3 11.3462V17H17V13.1072L14.6459 10.5741C14.4569 10.3707 14.1918 10.2551 13.9142 10.2549C13.6365 10.2547 13.3713 10.3699 13.1819 10.573L11.374 12.5126L7.52783 7.60538C7.33866 7.36403 7.04922 7.22281 6.74257 7.22226C6.43591 7.22171 6.14596 7.36189 5.95593 7.60256Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M23 2C23 1.44772 22.5523 1 22 1H2C1.44772 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H22C22.5523 23 23 22.5523 23 22V2ZM16.4444 9.40738C17.4672 9.40738 18.2963 8.57828 18.2963 7.55553C18.2963 6.53278 17.4672 5.70367 16.4444 5.70367C15.4217 5.70367 14.5926 6.53278 14.5926 7.55553C14.5926 8.57828 15.4217 9.40738 16.4444 9.40738ZM7.1411 9.1581L3 14.4027V21H21V16.5202L17.6243 12.8878C17.4353 12.6844 17.1702 12.5688 16.8925 12.5686C16.6148 12.5684 16.3496 12.6836 16.1603 12.8867L13.701 15.525L8.71299 9.16093C8.52383 8.91957 8.23438 8.77836 7.92773 8.7778C7.62108 8.77725 7.33113 8.91743 7.1411 9.1581Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M31 2.5C31 1.67157 30.3284 1 29.5 1H2.5C1.67157 1 1 1.67157 1 2.5V29.5C1 30.3284 1.67157 31 2.5 31H29.5C30.3284 31 31 30.3284 31 29.5V2.5ZM22 12.5C23.3807 12.5 24.5 11.3807 24.5 10C24.5 8.61929 23.3807 7.5 22 7.5C20.6193 7.5 19.5 8.61929 19.5 10C19.5 11.3807 20.6193 12.5 22 12.5ZM9.32274 12.0705L4 18.8116V28H28V21.7205L23.7026 17.0964C23.4191 16.7913 23.0215 16.6179 22.605 16.6175C22.1885 16.6172 21.7906 16.7901 21.5066 17.0948L18.3062 20.5282L11.6806 12.0747C11.3968 11.7127 10.9627 11.5009 10.5027 11.5C10.0427 11.4992 9.60779 11.7095 9.32274 12.0705Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;